export default {
  version: '1.0.0',
};



// WEBPACK FOOTER //
// ./assets/js/cf-dynamic-menu/info.js